import { render } from "./TimelineBox.vue?vue&type=template&id=64285486&scoped=true"
import script from "./TimelineBox.vue?vue&type=script&lang=js"
export * from "./TimelineBox.vue?vue&type=script&lang=js"

import "./TimelineBox.vue?vue&type=style&index=0&id=64285486&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64285486"]])

export default __exports__